"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadRequestException = void 0;
class BadRequestException extends Error {
}
exports.BadRequestException = BadRequestException;
//# sourceMappingURL=bad-request-exception.js.map